import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import './theme/reset.css'
import './theme/customBootstrap.scss'
import App from './App'
import AlertsProvider from './context/alerts'

const spaRoot = document.getElementById('root')

if (spaRoot) {
  ReactDOM.createRoot(spaRoot).render(
    <React.StrictMode>
      <AlertsProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AlertsProvider>
    </React.StrictMode>,
  )
}